import React from 'react';
import Footer from '../components/Footer';
import HeaderElement from '../components/HeaderElement';
import PlansPage from '../components/PlansPage';

const Plans = () => {
  return (
    <div>
      <HeaderElement />
      <PlansPage />
      <Footer />
    </div>
  );
};

export default Plans;
